<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tab1" href="/programm">
          <ion-icon :icon="timeOutline" />
          <ion-label>Programm</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab4" href="/orte">
          <ion-icon :icon="mapOutline" />
          <ion-label>Orte</ion-label>
        </ion-tab-button>
<!--
        <ion-tab-button tab="tab2" href="/neuigkeiten">
          <ion-icon :icon="newspaperOutline" />
          <ion-label>Neuigkeiten</ion-label>
          ion-badge>6</ion-badge
        </ion-tab-button>
-->
        <ion-tab-button tab="tab3" href="/informationen">
          <ion-icon :icon="bulbOutline" />
          <ion-label>Informationen</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue';
import { timeOutline, newspaperOutline, bulbOutline, mapOutline } from 'ionicons/icons';

export default defineComponent({
  name: 'TabsPage',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage, IonRouterOutlet },
  setup() {
    return {
      timeOutline,
      newspaperOutline,
      bulbOutline,
      mapOutline,
    }
  }
});
</script>
